import { Component } from '@angular/core';
import { AbstractBaseComponent } from '../abstract-base.component';
import { DateTimeFormatter, LocalDate } from "@js-joda/core";

@Component({
    template: '',
    host: {
        'class' : 'abstract-download-file-content'
      }    
  })
export abstract class AbstractDownloadFileContentComponent extends AbstractBaseComponent{

    protected downloadFile(content: Blob, fileName: string){

        let df = DateTimeFormatter.ISO_LOCAL_DATE;
        let dateStr = df.format(LocalDate.now()).replace(/-/g, '');

        fileName = dateStr + fileName;
        
        var fileURL = URL.createObjectURL(content);
        let anchor = document.createElement('a');
        anchor.download = fileName;
        anchor.href = fileURL;
        anchor.click();
    }
}